import { storageAssets } from '../storage_assets';
import {
    PROJECT_EIGHT_LOADING_BLINK_CSS,
    ProjectEightLoadingMark,
} from '../localassets/projectEightMotion';
import ProjectOnePage from '../pages/ProjectOnePage';
// import ProjectTwoPage from '../pages/ProjectTwoPage';
// import ProjectThreePage from '../pages/ProjectThreePage';
import ProjectFourPage from '../pages/ProjectFourPage';
import ProjectFivePage from '../pages/ProjectFivePage';
// import ProjectSixPage from '../pages/ProjectSixPage';
import ProjectSevenPage from '../pages/ProjectSevenPage';
import ProjectEightPage from '../pages/ProjectEightPage';
import ProjectNinePage from '../pages/ProjectNinePage';
import ProjectTenPage from '../pages/ProjectTenPage';

export const projectRegistry = [
    {
        id: 'design-review-command',
        title: 'Design review command',
        subtitle: 'Scaling design quality in the AI world',
        path: '/project-seven',
        delay: 3,
        hoverPreview: { type: 'image', src: storageAssets.aiDesignedUI, alt: 'Design review command' },
        component: ProjectSevenPage,
    },
    {
        id: 'breeze-incremental-travel',
        title: 'Inspiring incremental travel',
        subtitle: 'Designing Breeze Airways’ loyalty program',
        path: '/project-nine',
        delay: 4,
        hoverPreview: {
            type: 'image',
            src: storageAssets.breezeFinalDashboard,
            alt: 'Inspiring incremental travel.',
        },
        component: ProjectNinePage,
    },
    {
        id: 'askelephant-nothing-joins',
        title: 'Nothing joins the meeting',
        subtitle: 'Scaling AskElephant beyond meeting bots',
        path: '/project-ten',
        delay: 5,
        hoverPreview: {
            type: 'image',
            src: storageAssets.askElephantDesktopIntro,
            alt: 'Nothing joins the meeting — desktop intro',
        },
        component: ProjectTenPage,
    },
    {
        id: 'madder-controller',
        title: 'The madder controller',
        subtitle: 'Creating a controller used by thousands',
        path: '/project-one',
        delay: 6,
        hoverPreview: { type: 'image', src: storageAssets.finalIteration, alt: 'Final Iteration' },
        component: ProjectOnePage,
    },
    {
        id: 'svg-motion-code',
        title: 'Lightweight UI motion',
        subtitle: 'SVG motion animations with SMIL/CSS',
        path: '/project-eight',
        delay: 7,
        hoverPreview: {
            type: 'component',
            Component: ProjectEightLoadingMark,
            injectCss: PROJECT_EIGHT_LOADING_BLINK_CSS,
            componentStyle: {
                display: 'block',
                width: '120px',
                height: 'auto',
            },
            alt: 'Loading mark (CSS keyframes)',
        },
        component: ProjectEightPage,
    },
    {
        id: 'communication-as-graphics',
        title: 'Communication as graphics',
        subtitle: 'My work as an athletic graphic designer',
        path: '/project-four',
        delay: 8,
        hoverPreview: { type: 'video', src: storageAssets.byuCollage, alt: 'BYU Collage' },
        component: ProjectFourPage,
    },
    {
        id: 'no-more-narrator',
        title: 'No more narrator',
        subtitle: 'Rethinking the mafia group game',
        path: '/project-five',
        delay: 9,
        hoverPreview: { type: 'image', src: storageAssets.gameplay, alt: 'Gameplay' },
        component: ProjectFivePage,
    },
    /*
    {
        id: 'sayso-language-learning',
        title: 'A new take on language learning',
        subtitle: 'Designing and branding the sayso app',
        path: '/project-two',
        delay: 5,
        hoverPreview: { type: 'video', src: storageAssets.multipleChoice, alt: 'Sayso Demo' },
        component: ProjectTwoPage,
    },
    */
    /*
    {
        id: 'flight-data-visualization',
        title: 'Flight data visualization',
        subtitle: 'The finalist flight monitor for tfms',
        path: '/project-three',
        delay: 6,
        hoverPreview: { type: 'image', src: storageAssets.moaTwo, alt: 'MOA Two' },
        component: ProjectThreePage,
    },
    */
    /*
    {
        id: 'dev-portal-hackathon',
        title: 'The dev portal hack-a-thon',
        subtitle: 'Launching a dev portal used by 100+ devs',
        path: '/project-six',
        delay: 8,
        hoverPreview: { type: 'image', src: storageAssets.consoleIterationFinal, alt: 'Final Iteration' },
        component: ProjectSixPage,
    },
    */
];
